declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

interface AppConfig {
  NODE_ENV?: string;

  PUBLIC_URL?: string;
  PUBLIC_URL_BACK?: string;

  AUTH_HOST_KEYCLOAK_URL?: string;
  AUTH_HOST_API_URL?: string;
  DAM_HOST_API_URL?: string;
  CAMERA_HOST_API_URL?: string;
  POST_HOST_API_URL?: string;
  SENSORTHING_HOST_API_URL?: string;

  REALM?: string;
  CLIENT_ID?: string;

  RYNAN_X_API_KEY?: string;
  RYNAN_PASSWORD?: string;
  RYNAN_USERNAME?: string;
  RYNAN_VIETMAP_API_KEY?: string;

  AUTH_TOKEN?: string;
}

const config: AppConfig = {
  NODE_ENV: window._env_?.NODE_ENV || process.env.NODE_ENV,

  PUBLIC_URL: window._env_?.PUBLIC_URL || process.env.PUBLIC_URL,
  PUBLIC_URL_BACK: window._env_?.REACT_APP_PUBLIC_URL_BACK || process.env.REACT_APP_PUBLIC_URL_BACK,

  AUTH_HOST_KEYCLOAK_URL: window._env_?.REACT_APP_AUTH_HOST_KEYCLOAK_URL || process.env.REACT_APP_AUTH_HOST_KEYCLOAK_URL,
  AUTH_HOST_API_URL: window._env_?.REACT_APP_AUTH_HOST_API_URL || process.env.REACT_APP_AUTH_HOST_API_URL,
  DAM_HOST_API_URL: window._env_?.REACT_APP_DAM_HOST_API_URL || process.env.REACT_APP_DAM_HOST_API_URL,
  POST_HOST_API_URL: window._env_?.REACT_APP_POST_HOST_API_URL || process.env.REACT_APP_POST_HOST_API_URL,
  CAMERA_HOST_API_URL: window._env_?.REACT_APP_CAMERA_HOST_API_URL || process.env.REACT_APP_CAMERA_HOST_API_URL,
  SENSORTHING_HOST_API_URL: window._env_?.REACT_APP_SENSORTHING_HOST_API_URL || process.env.REACT_APP_SENSORTHING_HOST_API_URL,

  REALM: window._env_?.REACT_APP_REALM || process.env.REACT_APP_REALM,
  CLIENT_ID: window._env_?.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,

  RYNAN_X_API_KEY: window._env_?.REACT_APP_RYNAN_X_API_KEY || process.env.REACT_APP_RYNAN_X_API_KEY,
  RYNAN_PASSWORD: window._env_?.REACT_APP_RYNAN_PASSWORD || process.env.REACT_APP_RYNAN_PASSWORD,
  RYNAN_USERNAME: window._env_?.REACT_APP_RYNAN_USERNAME || process.env.REACT_APP_RYNAN_USERNAME,
  RYNAN_VIETMAP_API_KEY: window._env_?.REACT_APP_RYNAN_VIETMAP_API_KEY || process.env.REACT_APP_RYNAN_VIETMAP_API_KEY,

  AUTH_TOKEN: window._env_?.REACT_APP_AUTH_TOKEN || process.env.REACT_APP_AUTH_TOKEN,
};

export default config;
